































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  DocumentComponentsState,
  DocumentRepoState,
  DocumentRepoChartTab,
} from '@/utils/types/store';
import { DocumentRepoCommitDTO } from '@/utils/types/documentRepo/documentRepoCommit';
import DocumentParagraphView from './DocumentParagraphView.vue';

export default Vue.extend({
  name: 'DocumentParagraphComparison',
  components: {
    DocumentParagraphView,
  },
  computed: {
    ...mapState('documentRepo', {
      selectedChartTab: (state) => (state as DocumentRepoState).selectedChartTab,
    }),
    isByRevisionTabSelected(): boolean {
      return this.selectedChartTab === DocumentRepoChartTab.ByRevision;
    },
    ...mapState('documentComponents', {
      documentParagraphsByCommitId:
        (state) => (state as DocumentComponentsState).documentParagraphsByCommitId,
      prev: (state) => (state as DocumentComponentsState).prevParagraph,
      curr: (state) => (state as DocumentComponentsState).currParagraph,
      next: (state) => (state as DocumentComponentsState).nextParagraph,
    }),
    prevCommit(): DocumentRepoCommitDTO {
      return this.$store.getters['documentRepo/previousCommit'];
    },
    currCommit(): DocumentRepoCommitDTO {
      return this.$store.getters['documentRepo/currentCommit'];
    },
    nextCommit(): DocumentRepoCommitDTO {
      return this.$store.getters['documentRepo/nextCommit'];
    },
    prevDocument(): string[] {
      return this.renderDocument(this.prevCommit?.id);
    },
    currDocument(): string[] {
      return this.renderDocument(this.currCommit?.id);
    },
    nextDocument(): string[] {
      return this.renderDocument(this.nextCommit?.id);
    },
  },
  methods: {
    renderDocument(revisionId: string | undefined): string[] {
      if (!revisionId) {
        return [];
      }
      const components = this.documentParagraphsByCommitId[revisionId];
      if (!components) {
        return [];
      }
      return components.map((p) => p.sentences.map((s) => s.text).join(' '));
    },
  },
});
